import React, { useState } from "react";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import useMediaQuery from "@mui/material/useMediaQuery";

const CardTooltip = ({ children, element, placement = "bottom" }) => {
  const [open, setOpen] = useState(false);
  const isDesktop = useMediaQuery("(hover: hover)"); // Detects hover capability
  const isSmallDevice = useMediaQuery("(max-width:600px)"); // Detects small screens

  const HtmlTooltip = styled(({ className, ...props }) => (
    <Tooltip
      {...props}
      classes={{ popper: className }}
      slotProps={{
        popper: {
          sx: {
            [`&.${tooltipClasses.popper}[data-popper-placement*="bottom"] .${tooltipClasses.tooltip}`]:
              { marginTop: "0px" },
            [`&.${tooltipClasses.popper}[data-popper-placement*="top"] .${tooltipClasses.tooltip}`]:
              { marginBottom: "0px" },
            [`&.${tooltipClasses.popper}[data-popper-placement*="right"] .${tooltipClasses.tooltip}`]:
              { marginLeft: "0px" },
            [`&.${tooltipClasses.popper}[data-popper-placement*="left"] .${tooltipClasses.tooltip}`]:
              { marginRight: "0px" },
          },
        },
      }}
    />
  ))(() => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "transparent",
      fontSize: "1em",
      fontFamily: "Lato",
      margin: isSmallDevice ? "0px" : "30px", // ✅ Dynamic margin
    },
  }));

  const handleTooltipClose = () => setOpen(false);
  const handleTooltipToggle = (event) => {
    if (!isDesktop) {
      event.stopPropagation();
      setOpen((prev) => !prev);
    }
  };

  return (
    <ClickAwayListener onClickAway={handleTooltipClose}>
      <div>
        <HtmlTooltip
          placement={isDesktop ? placement : "top"}
          title={<>{children}</>}
          open={open} // Keep open controlled in all cases
          onOpen={isDesktop ? () => setOpen(true) : undefined} // Open on hover for desktop
          onClose={isDesktop ? () => setOpen(false) : undefined} // Close on hover for desktop
          disableHoverListener={!isDesktop} // Disable hover for mobile
          disableFocusListener={!isDesktop} // Disable focus for mobile
          disableTouchListener={isDesktop} // Disable touch events for desktop
        >
          <div onClick={handleTooltipToggle}>
            <Button
              sx={{
                minWidth: "24px",
                backgroundColor: "transparent",
                padding: 0,
              }}
            >
              {element}
            </Button>
          </div>
        </HtmlTooltip>
      </div>
    </ClickAwayListener>
  );
};

export default CardTooltip;
